import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import PrivateRoute from './collectors_dashboard/PrivateRoute'
import Accounts from './collectors_dashboard/Accounts'
import PayoutConfiguration from './collectors_dashboard/PayoutConfiguration'

import Users from './collectors_dashboard/Users'
import Login from './collectors_dashboard/Login'
import InviteAccept from './collectors_dashboard/InviteAccept'
import Notifications from './collectors_dashboard/Notifications'
const CollectorsDashboardRoot = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/collectors' element={<Login />} />
        <Route path='/collectors/invite' element={<InviteAccept />} />
        <Route
          path='/collectors/accounts'
          element={
            <PrivateRoute>
              <Accounts />
            </PrivateRoute>
          }
        />
        <Route
          path='/collectors/direct_deposit'
          element={
            <PrivateRoute>
              <PayoutConfiguration />
            </PrivateRoute>
          }
        />

        <Route
          path='/collectors/users'
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path='/collectors/notifications'
          element={
            <PrivateRoute>
              <Notifications />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default CollectorsDashboardRoot
